import { useEffect, useCallback } from "react";
import { refershTokenApi } from "../../services/users/users.service";

const SESSION_TIMEOUT = 15 * 60 * 1000;
const REFRESH_TOKEN_TIMEOUT = 10 * 60 * 1000; // 10 minutes

interface Props {
  onLogout: () => void;
}

const SessionTimeout: React.FC<Props> = ({ onLogout }) => {
  const resetSessionTimeout = useCallback(() => {
    clearTimeout((window as any).sessionTimeoutId);
    (window as any).sessionTimeoutId = setTimeout(() => {
      onLogout();
    }, SESSION_TIMEOUT);
  }, [onLogout]);

  const startRefreshTokenLoop = useCallback(() => {
    clearInterval((window as any).refreshIntervalId);
    (window as any).refreshIntervalId = setInterval(() => {
      refershTokenApi();
    }, REFRESH_TOKEN_TIMEOUT);
  }, []);

  useEffect(() => {
    resetSessionTimeout();
    startRefreshTokenLoop();

    const activityEvents = ["mousemove", "keydown", "click", "scroll"];
    activityEvents.forEach((event) =>
      window.addEventListener(event, resetSessionTimeout),
    );

    return () => {
      clearTimeout((window as any).sessionTimeoutId);
      clearInterval((window as any).refreshIntervalId);
      activityEvents.forEach((event) =>
        window.removeEventListener(event, resetSessionTimeout),
      );
    };
  }, [resetSessionTimeout, startRefreshTokenLoop]);

  return null;
};

export default SessionTimeout;
